import isArray from "lodash/isArray";

const validator = {
  getMessage() {
    return "The total file size uploaded exceeds the maximum file size allowed.";
    // return field + " file(s) size must be less than " + utils.formatBytes(size);
  },
  validate(value, size) {
    if (isNaN(size)) {
      return false;
    }

    if (isArray(value)) {
      return value.every(
        file =>
          file.size <= size || file.byteSize <= size || file.bytesize <= size
      );
    } else {
      return (
        value.size <= size || value.byteSize <= size || value.bytesize <= size
      );
    }
  }
};

export default validator;
